import { AbsUtente } from "./AbsUtente"

export class Utente extends AbsUtente {

}